import { type KeyboardEvent, useCallback } from 'react'
import { type Observable } from 'rxjs'
import { NumericInput } from '@/components/inputs/NumericInput'

export interface NumericQuestionAnswerEditorProps {
  value: number | null
  decimalPlaces: number
  isDisabled: boolean
  onChange: (value: number | null | undefined) => unknown
  focus$?: Observable<unknown>
  onFocus?: () => unknown
  onEnterDown?: (e: KeyboardEvent) => unknown
  isNotValid?: boolean
  testId?: string
}

export function NumericQuestionAnswerEditor({
  value,
  decimalPlaces,
  isDisabled,
  onChange,
  onEnterDown,
  focus$,
  onFocus,
  isNotValid,
  testId,
}: NumericQuestionAnswerEditorProps) {
  const keyDown = useCallback(
    (e: KeyboardEvent) => e.key === 'Enter' && onEnterDown?.(e),
    [onEnterDown],
  )

  return (
    <NumericInput
      isDisabled={isDisabled}
      value={value ?? undefined}
      mode="draft"
      precision={decimalPlaces}
      placeholder="Numeric..."
      onChange={onChange}
      onKeyDown={keyDown}
      onFocus={onFocus}
      focus$={focus$}
      isNotValid={isNotValid}
      data-test={testId}
    />
  )
}
